import React from 'react';
import { makeStyles } from 'design-system/styles';
import { Button } from '@scale/scaleui';
interface FrameViewProps {
  src: string;
}

const FrameView: React.FC<FrameViewProps> = props => {
  const classes = useStyles();
  return (
    <div className={classes.device + ' flex flex-col gap-2 '}>
      <Button
        className="w-fit border-none self-start"
        size="lg"
        variant="outline"
        icon={{
          position: 'left',
          type: ['fas', 'external-link'],
          variant: 'outline',
        }}
        onClick={() => window.open(props.src, '_blank')}
      >
        Open in new tab
      </Button>
      <div className={classes.content}>
        <iframe src={props.src} sandbox="" className={classes.frame} />
      </div>
    </div>
  );
};

FrameView.displayName = 'FrameView';

const useStyles = makeStyles({
  device: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: 8,
    paddingBottom: 8,
  },
  content: {
    width: 800,
    flex: 1,
    background: 'white',
    padding: 4,
    borderRadius: 4,
  },
  frame: {
    border: 'none',
    width: '100%',
    height: '100%',
    overflowY: 'scroll',
  },
});

export default FrameView;
